import presentationModules from './presentation/index'
import pricingModules from './pricing/index'
import configurationModules from './configuration/index'
import zoomAppModule from './zoomApp.module'
import homePage from './homePage.module'
import notificationModule from './notification.module'
import slidesGeneratorFeedbackModule from './openAI/slidesGeneratorFeedback.module'
import openAIModules from './openAI/index'
import aiPotentialIssuesModule from './openAI/aiPotentialIssues.module'
import userAdsCampaignModule from './userAdsCampaign.module'
import trialPlanModule from './trialPlan.module'
import rightColumnModules from './right-column/index'
import wordCloudModule from './wordcloud.module.js'
import hotkeyModules from './hotkey'
import slideModules from './slide/index'
import uploaderModules from './uploader/index'
import featureTogglesModule from './featureToggles.module'
import emailVerificationModule from './email-verification.module'
import categorise from './slides/categorise.module'
import liveStatsModule from './liveStats.module'
import liveStatsV2Module from './live-stats-v2/live-stats.module'
import progressBarModule from './progressBar.module'
import slideOptionModule from './slide-options'
import userSettingsModule from './user-settings/index'
import featureSettingsModule from './featureSettings.module'
import trash from './trash.module'
import keyword from './keyword.module'
import systemConnection from '@/vuex/modules/system/system-connection.module'
import questionRecommendations from './question-recommendations.module'
import presetModule from './preset.module'
import imageKeywordSuggestions from './image-keyword-suggestion.module'
import kvSyncModule from './kvSync.module'
import resourceManagement from './resource-management.module'
import leaderboardModule from './leaderboard.module'
import redirectModule from './redirect.module'
import history from './history/history.module'
import wheelEvent from './wheelEvent.module'
import inlineCSAT from './inlineCSAT.module'
import templatesModule from '@/vuex/modules/templates/templates.module'
import preventLockScreenModule from '@/vuex/modules/prevent-lock-screen/prevent-lock-screen.module'
import ahaAIModules from './aha-ai/index'
import hackathong2025Module from '@/vuex/modules/hackathon-2025/hackathon-2025.module'
import embedSlide from './embed-slide.module'
import slideAnnotationsModule from './slide-annotations/slide-annotations.module'
import multipleSessionsModule from '@/vuex/modules/multiple-session/multiple-session.module'
import movePresentationModule from './move-presentation.module'
import googleRecaptchaV3Module from '@/vuex/modules/google-recaptcha-v3/google-recaptcha-v3.module'
import aiChatbotModules from './ai-chatbot/index'
import pptAddinModule from '@/vuex/modules/ppt-addin/ppt-addin.module'
import adminAnalyticsModule from './admin-analytics.module'
import teamSettingsPaywallModule from './team-settings-paywall.module'
import planModule from './plan.module'
import reportSessionModule from './report-session/reportSession.module'
import skipSlideModule from '@/vuex/modules/skip-slide/skip-slide.module'
import nextBack from './nextBack.module'
import optimizeEditorLoadModule from './presentation/optimize-editor-load.module'
import accountModule from './account/account.module'
import myPhotoModule from './upload-image/my-photo.module'
import slideAttributes from './slide-attributes/slide-attributes.module'
import slidePluginModule from './slide-plugin/slide-plugin.module'
import loadingPageModule from '@/vuex/modules/loading-page/loading-page.module'
import submissionCountModule from './submissionCount.module'
import castingScreen from './casting-screen'
import referralModule from './referral.module'
import embedAppModule from './embed-app/embed-app.module'
import presenterControlBarModule from './presenterControlBar.module'
import slideMarketplaceModule from './slideMarketplace.module'
import slidePickerLayoutModule from './slidePickerLayout.module'

export default {
  ...presentationModules,
  ...pricingModules,
  ...configurationModules,
  zoomApp: zoomAppModule,
  trialPlan: trialPlanModule,
  homePage,
  categorise,
  notificationModule,
  wordCloud: wordCloudModule,
  liveStats: liveStatsModule,
  liveStatsV2: liveStatsV2Module,
  kvSync: kvSyncModule,
  resource: resourceManagement,
  slideOptionModule,
  ...slidesGeneratorFeedbackModule,
  ...openAIModules,
  userAdsCampaign: userAdsCampaignModule,
  userSettings: userSettingsModule,
  featureSettings: featureSettingsModule,
  ...rightColumnModules,
  ...hotkeyModules,
  ...slideModules,
  ...uploaderModules,
  featureToggles: featureTogglesModule,
  emailVerification: emailVerificationModule,
  progressBar: progressBarModule,
  trash,
  keyword,
  imageKeywordSuggestions,
  systemConnection,
  questionRecommendations,
  presetModule,
  leaderboard: leaderboardModule,
  redirectModule,
  history,
  wheelEvent,
  inlineCSAT,
  templates: templatesModule,
  preventLockScreen: preventLockScreenModule,
  ...ahaAIModules,
  hackathong2025: hackathong2025Module,
  embedSlide,
  slideAnnotations: slideAnnotationsModule,
  multipleSessions: multipleSessionsModule,
  movePresentation: movePresentationModule,
  googleRecaptchaV3: googleRecaptchaV3Module,
  ...aiChatbotModules,
  pptAddin: pptAddinModule,
  adminAnalytics: adminAnalyticsModule,
  teamSettingsPaywall: teamSettingsPaywallModule,
  planModule,
  reportSession: reportSessionModule,
  skipSlide: skipSlideModule,
  nextBack,
  optimizeEditorLoadModule,
  accountModule,
  myPhoto: myPhotoModule,
  slideAttributes,
  slidePlugin: slidePluginModule,
  loadingPage: loadingPageModule,
  aiPotentialIssues: aiPotentialIssuesModule,
  submissionCount: submissionCountModule,
  castingScreen,
  referral: referralModule,
  embedApp: embedAppModule,
  presenterControlBar: presenterControlBarModule,
  slideMarketplace: slideMarketplaceModule,
  slidePickerLayout: slidePickerLayoutModule,
}
